module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/klEQVQ4T6XTIU8DQRAF4Dd3SAQCUQEOUdRdZmQRbYLEIvh1/AQkJIhKDGtOXEqCg6RNEJUj9pIle+letttDsD375n3Zm80SM78S0dRae9s0zQeij5nfAJx3XXeXZmGMROQLwAWAjbV2Hg+KyI8HxrIYmAJYApikg1VV3ZRl+UxEp38h5CURyUZ64BhkAHKRPSAHOQBGkG9jzGX41XixzrnPUaCu61lRFC+77a+MMdcBiDPn3PsBkJZVddG27cYDY9ke8N+yhwcgp+xP1QO55R44ptwDIrLevYNVvDAAJ8y8DTeRZMObJWZ+JKIrVb0P2w4pMz8R0ZmqPqRZmPkFO4AGOfoGq5YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/study/statistics/icon.png
// module id = bQHb
// module chunks = 96